export enum SearchEventType {
  Scanner = 'scanner',
  Keyboard = 'keyboard',
  Manual = 'manual',
}

export enum ValidationType {
  None = 0,
  ValidDevice = 1,
  DeviceRegexMatchedButInvalidDevice = 2,
  InvalidPatient = 3,
  InvalidDevice = 4,
  RegexMatchDeviceInSameFacility = 5,
  RegexMatchDeviceInDifferentFacility = 6,
  RegexMatchWithMultipleDeviceTypes = 7
}

export enum ManualEntryReason {
  BarcodeDamaged = 1,
  BarcodeNotAvailable = 2,
  BarcodeWouldNotScan = 3,
  Other = 4
}

export enum ResponseStatus {
  Success = 'Success',
  Error = 'Error'
}

export enum SearchPage {
  Patient = 'Patient',
  Device = 'Device'
}

export enum PatientTherapy {
  NewTherapySession = 1,
  ContinuationOfTherapy = 2,
}
